import { render, staticRenderFns } from "./AttachmentCard.vue?vue&type=template&id=5622a28b&scoped=true"
import script from "./AttachmentCard.vue?vue&type=script&lang=js"
export * from "./AttachmentCard.vue?vue&type=script&lang=js"
import style0 from "./AttachmentCard.vue?vue&type=style&index=0&id=5622a28b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5622a28b",
  null
  
)

export default component.exports